import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
//import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Container,
  FormWrapper
} from "../Advertisers/CreateAdvertisers/CreateAdvertisersStyles"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAdvertiserById,
  updateAdvertiser,
} from "../../redux/slices/advertiserSlice";

import BackButton from "../../components/common/BackButton";
const EditAdvertisers = () => {
  const dispatch = useDispatch();
  const { advertiserId } = useParams();
  const { loading } = useSelector((state) => state.advertiser);
  const [initialFormData, setInitialFormData] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    skype: "",
    phoneNumber: "",
    companyName: "",
    location: "",
    userId: "",
  });
  // const [showPassword, setShowPassword] = useState(false);
  // const toggleType = () => {
  //   setShowPassword(!showPassword);
  // };

  useEffect(() => {
    dispatch(getAdvertiserById(advertiserId)).then((response) => {
      if (response.payload) {
        const fetchedData = response.payload.data;
        //console.log(fetchedData)

        //formData.userId = fetchedData.userId;
        const existingFormData = {
          userId: fetchedData.id || "",
          firstName: fetchedData.firstName || "",
          lastName: fetchedData.lastName || "",
          email: fetchedData.email || "",
          skype: fetchedData.skype || "",
          phoneNumber: fetchedData.phoneNumber || "",
          companyName: fetchedData.companyName || "",
          location: fetchedData.location || "",
        };

        setFormData(existingFormData);
        setInitialFormData(existingFormData); // Save initial data for comparison
      }
    });
  }, [dispatch, advertiserId]);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const trimFormValues = (values) => {
    const trimmedValues = {};
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        trimmedValues[key] = values[key].trim(); // Trim strings
      } else if (typeof values[key] === "object" && values[key] !== null) {
        // Recursively trim nested objects if any
        trimmedValues[key] = trimFormValues(values[key]);
      } else {
        trimmedValues[key] = values[key]; // Keep other types as they are
      }
    });
    return trimmedValues;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedFormData = trimFormValues(formData);
    const trimmedInitialData = trimFormValues(initialFormData);

    // Compare the trimmed form data
    if (
      JSON.stringify(trimmedFormData) === JSON.stringify(trimmedInitialData)
    ) {
      Swal.fire({
        title: "No Changes Made",
        text: "You have not made any changes to the campaign.",
        icon: "info",
      });
      return;
    }
console.log(formData);
dispatch(updateAdvertiser(formData));
  };

  return (
    <>
    <BackButton></BackButton>
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Update Advertiser</h3>
          <p>
            Set up an advertiser profile to get them started with campaigns and
            tracking.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormWrapper>
          <label htmlFor="firstName">First name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            placeholder="First name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="lastName">Last name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Last name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="phoneNumber">Phone number</label>
          <input
            type="number"
            id="phoneNumber"
            name="phoneNumber"
            placeholder="Phone number"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="skypeId">Skype ID</label>
          <input
            type="text"
            id="skype"
            name="skype"
            placeholder="Skype ID"
            value={formData.skype}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="companyName">Company Name</label>
          <input
            type="text"
            id="companyName"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        {/* <FormWrapper>
          <label htmlFor="currentPassword">Current Password</label>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Current password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          {showPassword ? (
            <FaEyeSlash className="eye" onClick={toggleType} />
          ) : (
            <FaEye className="eye" onClick={toggleType} />
          )}
        </FormWrapper> */}

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </form>
    </Container>
    </>
  );
};

export default EditAdvertisers;
